// extracted by mini-css-extract-plugin
export default {"formWrapper":"FormFieldTranslations_formWrapper__3o2r5"};